import { useEffect, useRef } from 'react';

export default function CursorSpotlight() {
  const spotRef = useRef<HTMLDivElement>(null);
  const dotRef = useRef<HTMLDivElement>(null);
  const ringRef = useRef<HTMLDivElement>(null);
  const mouse = useRef({ x: -999, y: -999 });
  const ring = useRef({ x: -999, y: -999 });
  const rafId = useRef<number>();

  useEffect(() => {
    // Skip entirely on touch devices
    if (window.matchMedia('(hover: none)').matches) return;

    const setOpacity = (v: string) => {
      if (spotRef.current) spotRef.current.style.opacity = v;
      if (ringRef.current) ringRef.current.style.opacity = v;
      if (dotRef.current) dotRef.current.style.opacity = v;
    };

    const onMove = (e: MouseEvent) => {
      mouse.current = { x: e.clientX, y: e.clientY };
      setOpacity('1');
      if (spotRef.current) {
        spotRef.current.style.transform = `translate(${e.clientX}px,${e.clientY}px)`;
      }
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${e.clientX}px,${e.clientY}px)`;
      }
    };

    const lerp = (a: number, b: number, t: number) => a + (b - a) * t;
    const animate = () => {
      ring.current.x = lerp(ring.current.x, mouse.current.x, 0.12);
      ring.current.y = lerp(ring.current.y, mouse.current.y, 0.12);
      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${ring.current.x}px,${ring.current.y}px)`;
      }
      rafId.current = requestAnimationFrame(animate);
    };

    window.addEventListener('mousemove', onMove, { passive: true });
    document.addEventListener('mouseleave', () => setOpacity('0'));
    document.addEventListener('mouseenter', () => setOpacity('1'));
    rafId.current = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener('mousemove', onMove);
      if (rafId.current) cancelAnimationFrame(rafId.current);
    };
  }, []);

  return (
    <>
      <div
        ref={spotRef}
        className="pointer-events-none fixed top-0 left-0 z-[9996]"
        style={{
          width: 360,
          height: 360,
          marginLeft: -180,
          marginTop: -180,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(16,185,129,0.06) 0%, rgba(6,182,212,0.02) 45%, transparent 70%)',
          opacity: 0,
          transition: 'opacity 0.4s ease',
          willChange: 'transform',
        }}
      />
      <div
        ref={ringRef}
        className="pointer-events-none fixed top-0 left-0 z-[9998]"
        style={{
          width: 32,
          height: 32,
          marginLeft: -16,
          marginTop: -16,
          borderRadius: '50%',
          border: '1.5px solid rgba(16,185,129,0.4)',
          opacity: 0,
          transition: 'opacity 0.4s ease',
          willChange: 'transform',
          boxShadow: '0 0 10px rgba(16,185,129,0.1)',
        }}
      />
      <div
        ref={dotRef}
        className="pointer-events-none fixed top-0 left-0 z-[9999]"
        style={{
          width: 6,
          height: 6,
          marginLeft: -3,
          marginTop: -3,
          borderRadius: '50%',
          background: '#10b981',
          opacity: 0,
          transition: 'opacity 0.4s ease',
          willChange: 'transform',
          boxShadow: '0 0 8px rgba(16,185,129,0.6)',
          mixBlendMode: 'screen',
        }}
      />
    </>
  );
}
